/**
 * @generated SignedSource<<776d61658c09d4fef3e1bd0793903b0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments$data = {
  readonly reviewerDashboardFlowComments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly comment: {
          readonly commentText: string;
          readonly createdAt: Date | null | undefined;
          readonly gwtUser: {
            readonly fullName: string;
            readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_gwtUser">;
          } | null | undefined;
          readonly rowId: UUID;
          readonly unread: boolean;
        } | null | undefined;
        readonly flow: {
          readonly name: string;
          readonly rowId: UUID;
          readonly " $fragmentSpreads": FragmentRefs<"FlowLink_flow">;
        } | null | undefined;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments";
};
export type ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments$key = {
  readonly " $data"?: ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments">;
};

import ReviewerDiscussionCardFlowCommentsPaginationQuery_graphql from './ReviewerDiscussionCardFlowCommentsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "reviewerDashboardFlowComments"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ReviewerDiscussionCardFlowCommentsPaginationQuery_graphql
    }
  },
  "name": "ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments",
  "selections": [
    {
      "alias": "reviewerDashboardFlowComments",
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "fields": [
                        {
                          "fields": [
                            {
                              "kind": "Variable",
                              "name": "equalTo",
                              "variableName": "userId"
                            }
                          ],
                          "kind": "ObjectValue",
                          "name": "reviewerId"
                        }
                      ],
                      "kind": "ObjectValue",
                      "name": "some"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "flowReviewers"
                }
              ],
              "kind": "ObjectValue",
              "name": "flow"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "UNREAD_COMMENTS_CREATED_AT_DESC"
        }
      ],
      "concreteType": "ReviewerDashboardFlowCommentsConnection",
      "kind": "LinkedField",
      "name": "__ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReviewerDashboardFlowCommentsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ReviewerDashboardFlowComment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Comment",
                  "kind": "LinkedField",
                  "name": "comment",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "unread",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "commentText",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GwtUser",
                      "kind": "LinkedField",
                      "name": "gwtUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fullName",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "UserAvatar_gwtUser"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Flow",
                  "kind": "LinkedField",
                  "name": "flow",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "FlowLink_flow"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "8a806b9b9868c4ad3d5f15311a22575e";

export default node;
